import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/questionnaires/(pages)')({
  // Layout route for every questionnaires screen, so the read permission is
  // asked once here rather than on each child route.
  beforeLoad: async ({ location }) => {
    const perms = await ensurePermissions();
    if (!perms.questionnaires.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    if (
      location.pathname === '/questionnaires' ||
      location.pathname === '/questionnaires/'
    ) {
      throw redirect({
        to: '/questionnaires/my-questionnaires/active',
      });
    }
  },
});
